<template>
  <ul class="list">
    <li
      v-for="({ href, isPremiumOnly, title, iconName }, index) in links"
      :key="index"
      :class="[`list__item--${iconName}`]"
      class="list__item item"
    >
      <page-link-button
        :href="href"
        :title="title"
        :is-premium-only="isPremiumOnly"
        :is-free-member="isFreeMember"
        :icon-name="iconName"
        :is-justify-start="true"
        class="item__button"
      />
    </li>
  </ul>
</template>

<script>
import { VTRestaurantId } from '@/mikan/_shared/types/vueTypes/restaurant';
import {
  buildBookingIndexUrl,
  buildHomepageIndexUrl,
  buildEdittingRestaurantInformationUrl,
  buildAccessAnalysisIndexUrl,
  buildSettingIndexUrl,
  buildCheckReservationsUrl,
} from '@/mikan/_shared/lib/urlBuilders';
import PageLinkButton from '@/mikan/_shared/components/molecules/PageLinkButton.vue';

export default {
  components: {
    PageLinkButton,
  },
  props: {
    restaurantId: VTRestaurantId.isRequired,
    isFreeMember: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    links() {
      return [
        {
          href: buildBookingIndexUrl(this.restaurantId),
          title: '予約の確認',
          iconName: 'booking',
          isPremiumOnly: true,
        },
        {
          href: buildCheckReservationsUrl(this.restaurantId),
          title: '予約実績',
          iconName: 'reservation',
        },
        {
          href: buildHomepageIndexUrl(this.restaurantId),
          title: 'ホームページ設定',
          iconName: 'homepage_settings',
          isPremiumOnly: true,
        },
        {
          href: buildEdittingRestaurantInformationUrl(this.restaurantId),
          title: '店舗の編集',
          iconName: 'restaurant_editing',
        },
        {
          href: buildAccessAnalysisIndexUrl(this.restaurantId),
          title: 'アクセス解析',
          iconName: 'analysis',
        },
        {
          href: buildSettingIndexUrl(this.restaurantId),
          title: '設定',
          iconName: 'setting',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.list {
  @include for-tb-pc {
    display: flex;
    align-items: stretch;
    gap: 20px;
  }

  @include for-sp {
    display: grid;
    grid-gap: 4px;
    grid-template-areas:
      'booking            booking            reservation reservation homepage_settings     homepage_settings'
      'restaurant_editing restaurant_editing analysis    analysis    setting              setting';
    grid-template-columns: repeat(6, 1fr);
  }

  &__item {
    @include for-tb-pc {
      flex: 1;
    }

    @include for-sp {
      &--booking {
        grid-area: booking;
      }

      &--reservation {
        grid-area: reservation;
      }

      &--seat {
        grid-area: seat;
      }

      &--restaurant_editing {
        grid-area: restaurant_editing;
      }

      &--analysis {
        grid-area: analysis;
      }

      &--setting {
        grid-area: setting;
      }

      &--homepage_settings {
        grid-area: homepage_settings;
      }
    }
  }
}

.item {
  box-shadow: 0 0 8px 0 rgba($color-black, 0.1);

  @include for-sp {
    height: 110px;
  }

  &__button {
    text-align: center;

    @include for-tb-pc {
      height: 140px;
      padding: 32px 18px 14px;
    }
    @include for-sp {
      padding: 15px 6px 0;
    }
  }
}
</style>
